import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import styled from "styled-components";
import { Flex, Button, ButtonClass, Loading } from "src/components/ui";
import closeIcon from "src/assets/images/common/closeIcon.svg";
import { theme } from "src/styles/Theme";
import { useUpdateWithdrawalBankMutation } from "src/store/services/userApi";
import { toast, ToastContainer } from "react-toastify";
import miscService from "src/service/miscServices";
import userServices from "src/service/userServices";
import { ArtisansServices } from "src/service/ArtisansServices";

const Wrapper = styled.div`
  .heading {
    background-color: ${(props) => props.theme.colors.gray_04};
    padding: 10px 20px;
    height: 56px;
    align-items: center;
    display: flex;
    border-radius: 8px 8px 0 0;

    img {
      padding: 8px;
      &:hover {
        cursor: pointer;
        background-color: ${(props) => props.theme.colors.lilac};
        transition: 0.3s;
        border-radius: 50%;
      }
    }

    p {
      font-weight: 700;
      font-size: 16px;
      line-height: 20px;
      color: ${(props) => props.theme.colors.text_01};
    }
  }

  .content {
    border-radius: 0 0 8px 8px;
    padding: 20px;
    .label {
      font-size: 14px;
      line-height: 20px;
      color: ${(props) => props.theme.colors.text_01};
      margin-bottom: 5px;
    }
    input,
    textarea {
      padding: 10px 14px;
      border: 1px solid ${(props) => props.theme.colors.text_02};
      background-color: ${(props) => props.theme.colors.gray_04};
      color: ${(props) => props.theme.colors.text_01};
      font-size: 16px;
      line-height: 24px;
      box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
      border-radius: 8px;
      width: 100%;
      height: 44px;
      outline: none;
      &:focus {
        border: 1px solid ${(props) => props.theme.colors.purple};
      }
    }

    textarea {
      resize: none;
      height: 235px;
      background-color: ${(props) => props.theme.colors.white};
    }
    .button {
      padding: 8px 15px;
      background-color: ${(props) => props.theme.colors.gray_04};
      border-radius: 8px;
    }
    .error {
      font-weight: 200;
      color: red;
      margin-top: 3px;
    }
  }
`;
const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 532,
  maxWidth: "90%",
  bgcolor: theme.colors.white,
  borderRadius: "8px",
  boxShadow: 24,
  outline: "none",
};

export const WithdrawalBankAccount: React.FC<{
  open: boolean;
  userId: string;
  artisan: boolean;
  withdrawalBank: {
    account_name: string;
    account_number: string;
    bank_name: string;
    bank_code: string;
    // amount: Number;
  };
  setWallet_up: React.Dispatch<React.SetStateAction<boolean>>;
  handleClose: () => void;
}> = ({ open, handleClose, userId, artisan, withdrawalBank, setWallet_up }) => {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [isValidateButtonDisabled, setIsValidateButtonDisabled] =
    React.useState<boolean>(false);
  const [banks, setBanks] = React.useState<any[]>([]);
  const [withdrawalBankPayload, setWithdrawalBankPayload] = React.useState({
    amount: 0,
    user_id: "",
    narration: "",
    description: "",
  });
  // Update state when withdrawalBank changes
  React.useEffect(() => {
    if (withdrawalBank) {
      setWithdrawalBankPayload({
        amount: 0,
        user_id: userId,
        narration: "",
        description: "",
      });
    }
  }, [withdrawalBank]);

  // Log the updated state
  //   React.useEffect(() => {
  //     console.log("Withdrawal Bank Payload:", withdrawalBankPayload);
  //   }, [withdrawalBankPayload]);

  //   console.log(withdrawalBank?.bank_name);
  React.useEffect(() => {
    miscService
      .getBanks()
      .then((res) => {
        // console.log(res?.data?.payload?.data);
        setBanks(res?.data?.payload.data);
      })
      .catch((err) => console.log(err.response));
  }, []);

  const onChange = async (e: any) => {
   
      setWithdrawalBankPayload({
        ...withdrawalBankPayload,
        [e.target.name]: e.target.value,
      });
    
  };

  const submitHandler = (e: any) => {
    e.preventDefault();
    setIsLoading(true);
      ArtisansServices.withdrawalBank({
        amount: withdrawalBankPayload.amount,
        description: withdrawalBankPayload.description,
        narration: withdrawalBankPayload.narration,
        user_id: withdrawalBankPayload.user_id,
      })
        .then((res) => {
          toast.success(res?.data.message);
          setWallet_up(true)
        })
        .catch((err: any) => {
          toast.error(err.response.error.message);
        })
        .finally(() => {
          setIsLoading(false);
        });

      console.log({
        amount: withdrawalBankPayload.amount,
        description: withdrawalBankPayload.description,
        narration: withdrawalBankPayload.narration,
        user_id: withdrawalBankPayload.user_id,
      });
    
  };

  return (
    <>
      <ToastContainer />
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Wrapper>
              <div className="heading">
                <Flex
                  justify="space-between"
                  align="center"
                  style={{ width: "100%" }}
                >
                  <p>Credit Wallet Balance</p>
                  <img src={closeIcon} alt="x" onClick={handleClose} />
                </Flex>
              </div>
              <div className="content">
                <Flex direction="column">
                  <input
                    type="text"
                    value={withdrawalBankPayload.user_id}
                    onChange={onChange}
                    name="amount"
                    hidden={true}
                  />
                  <div className="to">
                    <p className="label">Amount</p>
                    <input
                      type="text"
                      value={withdrawalBankPayload.amount}
                      onChange={onChange}
                      name="amount"
                    />
                  </div>
                  <div className="to">
                    <p className="label">Narration</p>
                    <input
                      type="text"
                      value={withdrawalBankPayload.narration}
                      onChange={onChange}
                      name="narration"
                    />
                  </div>
                  <div className="to">
                    <p className="label">Description</p>
                    <input
                      type="text"
                      value={withdrawalBankPayload.description}
                      onChange={onChange}
                      name="description"
                    />
                  </div>
                  <Flex justify="space-between">
                    <div className="button">
                      <Button
                        classes={[ButtonClass.SOLID]}
                        onClick={submitHandler}
                        style={{
                          backgroundColor: theme.colors.purple,
                          minWidth: "100px",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        {isLoading ? (
                          <Loading color="white" />
                        ) : (
                          <span>Submit</span>
                        )}
                      </Button>
                    </div>
                  </Flex>
                </Flex>
              </div>
            </Wrapper>
          </Box>
        </Fade>
      </Modal>
    </>
  );
};

export default WithdrawalBankAccount;
